export const NOTIFICATION_TAB = 0;
export const MESSAGE_TAB = 1;
